module.exports = __webpack_public_path__ + "static/media/game.5a31cda3.png";